module.exports = __webpack_public_path__ + "47bcf513cce8dc77e6a424287df74954.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/frog-prince-s.png
// module id = 2030
// module chunks = 0